<template>
    <dtunes-modal :dialog="dialog" @openModal = "dialog = true" @closeModal = "dialog = false">
    <template v-slot:button>Permissions</template>
    <template v-slot:content>
      <v-card class="pad-10">
        <v-card-title class="d-flex justify-center">
          <p class="text-center">Edit Permissions</p>
        </v-card-title>
        <v-card-text>
            <label for="">Add Permissions</label>
            <v-select
              v-model="value"
              :items="Permissions"
              item-text="name"
              item-value="key"
              :menu-props="{ maxHeight: '500' }"
              color="auto"
              outlined
              multiple
            >
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index === 0">
                  <span>{{ item.name }}</span>
                </v-chip>
                <span v-if="index === 1" class="grey--text text-caption">
                  (+{{ value.length - 1 }} others)
                </span>
              </template>
            </v-select>
          <br />
          <default-button :disabled="!isComplete" :loading="loading"  @click="addPermissions()">Add Permissions</default-button>
        </v-card-text>
      </v-card>
    </template>
  </dtunes-modal>
</template>

<script>
// ============= IMPORT COMPONENTS ============
import DefaultButton from "@/components/Buttons/default-button.vue";
import DtunesModal from "@/components/dtunes-modal.vue";

// =========== IMPORT SERVICES =============
import { PermissionService } from "@/services";
export default {
    components:{
        DefaultButton,
        DtunesModal
    },
    props:{
        details:{
            type:Object,
            required: true
        }
    },
    data: () => ({
        Permissions: [],
        value: [],
        loading: false,
        dialog : false
    }),
    computed: {
        isComplete() {
            return this.value.length > 0 && this.value != this.details.permissions;
        },
    },
    mounted() {
        this.getPermissions();
        this.value = this.details.permissions;
    },
    methods:{
        async getPermissions() {
            const data = await PermissionService.getPermissions();
            this.Permissions = data;
        },
        async addPermissions(){
            try {
                this.loading = true;
                const data = await PermissionService.addPermissions({
                    id:this.details.id,
                    permissions : this.value
                })
                console.log(data);
                this.loading = false;
                this.$store.dispatch('toast', {
                    message: ` ${this.details.email} permissions granted`,
                    variant: 'success'
                });
                this.dialog = false;
                this.$emit('closeModal')
            } catch (error) {
                this.loading = false;
                console.log(error);
            }
        }
    }
    
}
</script>